export default function HoldingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F7F5EE] text-[#0B2545] fade-in">
      <main className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        <div className="w-full max-w-[720px]">
          <h1 className="font-serif font-medium tracking-tight text-5xl sm:text-6xl md:text-7xl leading-none">
            AAEN Holdings
          </h1>

          <div aria-hidden="true" className="mx-auto mt-8 h-px w-10 bg-[#FFB300]" />

          <h2 className="mt-8 text-base sm:text-lg font-normal text-[#0B2545]/70">
            A private holding company.
          </h2>
          <p className="mt-3 text-sm text-[#0B2545]/45">
            Established 2026. Wyoming, USA.
          </p>

          <section className="mt-24" aria-label="Holdings">
            <p className="text-xs uppercase tracking-[0.25em] text-[#0B2545]/40">
              Holdings
            </p>
            <p
              data-testid="holdings-aiservices"
              className="mt-4 font-serif text-2xl sm:text-3xl text-[#0B2545]"
            >
              AAEN AI Services
            </p>
            <p
              data-testid="holdings-govsolutions"
              className="mt-3 font-serif text-2xl sm:text-3xl text-[#0B2545]"
            >
              AAEN Government Solutions
            </p>
            <p
              data-testid="holdings-realestate"
              className="mt-3 font-serif text-2xl sm:text-3xl text-[#0B2545]"
            >
              AAEN Real Estate Holdings
            </p>
            <p
              data-testid="holdings-kayanin"
              className="mt-3 font-serif text-2xl sm:text-3xl text-[#0B2545]"
            >
              Kayanin
            </p>
          </section>
        </div>
      </main>

      <footer className="px-6 pb-10 text-center">
        <p className="text-xs tracking-wide text-[#0B2545]/60">AAEN Holdings LLC</p>
        <p className="mt-1.5 text-xs text-[#0B2545]/40">
          © 2026 AAEN Holdings. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
